module.exports = "/images/820c772f1b1abbb6325a1ea7387a4a7b.svg";